import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const RedoIcon = (props: IconProps) => (
  <Icon
    fill="none"
    viewBox="0 0 16 16"
    color="currentColor"
    title={t`Redo`}
    {...props}
  >
    <Path
      fill="currentColor"
      d="M9.47 2.137a.75.75 0 0 1 1.06 0l3.333 3.333.017.018.014.016a.748.748 0 0 1 .12.188l.014.028a.747.747 0 0 1 0 .56l-.011.023a.74.74 0 0 1-.14.21c-.004.005-.008.012-.014.017L10.53 9.864a.75.75 0 0 1-1.06-1.06l2.053-2.054H6.334a2.918 2.918 0 0 0 0 5.833h2.333a.75.75 0 0 1 0 1.5H6.334a4.418 4.418 0 0 1-4.417-4.416A4.417 4.417 0 0 1 6.334 5.25h5.189L9.47 3.197a.75.75 0 0 1 0-1.06Z"
    />
  </Icon>
);
